import React from 'react';
import { useTranslation } from 'react-i18next';
import { Languages } from 'lucide-react';

const LanguageSwitcher = ({ variant = 'default' }) => {
  const { i18n } = useTranslation();

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  const languages = [
    { code: 'es', label: 'ES' },
    { code: 'en', label: 'EN' },
    { code: 'pt', label: 'PT' }
  ];

  if (variant === 'compact') {
    return (
      <div className="flex items-center gap-1">
        {languages.map((lang) => (
          <button
            key={lang.code}
            onClick={() => changeLanguage(lang.code)}
            className={`text-[10px] font-black px-1.5 py-0.5 rounded transition-all ${
              i18n.language.startsWith(lang.code)
                ? 'bg-[#141414] text-white'
                : 'text-gray-400 hover:text-gray-900'
            }`}
          >
            {lang.label}
          </button>
        ))}
      </div>
    );
  }

  return (
    <div className="flex items-center gap-2 border-r border-gray-100 pr-4 md:pr-8">
      <Languages size={16} className="text-gray-400" />
      <div className="flex gap-2">
        {languages.map((lang) => (
          <button
            key={lang.code}
            onClick={() => changeLanguage(lang.code)}
            className={`text-[10px] font-black px-2 py-1 rounded-md transition-all ${
              i18n.language.startsWith(lang.code)
                ? 'bg-[#141414] text-white'
                : 'text-gray-400 hover:text-gray-900'
            }`}
          >
            {lang.label}
          </button>
        ))}
      </div>
    </div>
  );
};

export default LanguageSwitcher;
